import React from "react";
import { Animated } from "react-native";
import { useStyles } from "./hooks/use-styles";
const Surface = ({ category, elevation = 0, style, ...rest }) => {
    const styles = useStyles(({ elevations, shapes, surfaceColor }) => ({
        surface: {
            ...elevations[elevation],
            ...(category ? shapes[category] : {}),
            backgroundColor: surfaceColor(elevation).hex(),
        },
    }), [category, elevation]);
    return <Animated.View style={[styles.surface, style]} {...rest}/>;
};
export default Surface;
